// PrathyushaDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import prathyushadoc from '../../../../assets/images/Doctorsimages/prathyaushadr.png' // Ensure path is correct
import favicon from "../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'

const PrathyushaDoc = () => {
  const navigate = useNavigate(); 
   useEffect(() => {
       document.title = "Dr. Prathyusha R | Best Oral, Maxillofacial Surgeon & Cosmetology Specialist in Chennai";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Prathyusha R (BDS, MDS), a highly skilled Oral and Maxillofacial Surgeon and cosmetology expert in Valasaravakkam, Chennai. Expert in advanced dental surgeries and cosmetology with 6 years of experience. Book your consultation at Smile Dental today."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best oral surgeon in Chennai, maxillofacial surgeon in Valasaravakkam, dental surgery specialist in Chennai, Dr. Prathyusha R oral surgeon, oral and maxillofacial surgery Chennai, tooth extraction specialist Valasaravakkam, dental implants specialist Chennai, female oral surgeon in Chennai, Smile Dental Valasaravakkam doctors, consultant oral surgeon near me, advanced dental surgery Chennai, jaw surgery specialist Valasaravakkam, cosmetology specialist Chennai, oral surgery and cosmetology expert Chennai"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-prathyusha-r-maxillofacial-surgery-and-cosmetology-chennai");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-prathyusha-r-maxillofacial-surgery-and-cosmetology-chennai");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');

  container.classList.add('veenadoc-pdf-mode');

  const originalStyles = new Map();

  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const marginLeft = 10;
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;

      const scaleFactor = availableWidth / canvasWidth;

      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;

      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Prathyusha_R_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Prathyusha R</span>
                  <span className="veenadoc-title-credentials">(BDS, MDS)</span>
                  <span className="veenadoc-title-location">Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Recognized as a premier <strong>Oral and Maxillofacial Surgeon and cosmetology specialist</strong> in Chennai. 
                    Serving as a Senior Consultant at Valasaravakkam, she brings <strong>6 years</strong> of dedicated clinical 
                    experience, combining surgical precision with a patient-centric approach for complex oral health and aesthetic concerns.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
                    className="veenadoc-btn-primary-gradient"
                    onClick={() => navigate('/bookconsultation')}
                  >
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={prathyushadoc} alt="Dr. Prathyusha R – Best Oral & Maxillofacial Surgeon and Cosmetology Expert in Valasaravakkam, Chennai" className="veenadoc-doctor-image" title='Dr. Prathyusha R – Best Oral & Maxillofacial Surgeon and Cosmetology Expert' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Prathyusha R</h2>
                  <p>
                    Dr. Prathyusha R (BDS, MDS) is recognized as a premier Oral and Maxillofacial Surgeon in Chennai. Her academic journey began at the prestigious Government Dental College - RIMS (Kadapa), where she completed her BDS. Driven by a passion for surgical excellence, she pursued her MDS in Oral and Maxillofacial Surgery from the CKS Teja Institute of Dental Sciences in Tirupati.
                  </p>
                  <p>
                    This rigorous training has equipped her with the skills necessary to handle a wide array of surgical procedures, ranging from routine extractions to complex facial reconstructions and advanced cosmetology treatments.
                  </p>
                </div>

                {/* Academic and Professional */}
                <div className="veenadoc-article-block">
                  <h2>Professional Journey & Clinical Mastery</h2>
                  <p>
                    Her career includes significant tenures at reputable institutions such as CKS Teja Dental College in Tirupati and Smile Dental in Chennai. Throughout her years of practice, she has successfully managed diverse cases, earning a reputation for delivering predictable and successful outcomes in both oral surgery and cosmetology.
                  </p>
                  <p>
                    Patients searching for a "maxillofacial surgeon in Valasaravakkam" choose Dr. Prathyusha for her meticulous planning. Her role as a Senior Consultant involves mentoring junior staff and ensuring that the clinic maintains its high standards of surgical and cosmetology excellence.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BDS, MDS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">6 Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Maxillofacial Surgery & Cosmetology</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Valasaravakkam, Chennai</span>
                    </div>
                  </div>
                </div>

                {/* Specialized Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Specialized Maxillofacial & Cosmetology Expertise</h2>
                  <p>
                    As a specialist in Oral and Maxillofacial Surgery and Cosmetology, Dr. Prathyusha focuses on the diagnosis and treatment of diseases, injuries, and defects involving both the functional and aesthetic aspects of the hard and soft tissues of the oral and maxillofacial region.
                  </p>
                  <p>
                    Her expertise is particularly valued by those looking for an oral surgery and cosmetology consultant near me who can address issues like impacted teeth, dental implants, jaw misalignments, and aesthetic enhancements.
                  </p>
                </div>
                 <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Prathyusha has gained recognition as a trichology doctor in chennai specializing in hair fall,  dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome  to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

                {/* Patient Care Approach */}
                <div className="veenadoc-article-block">
                  <h2>A Compassionate Approach to Surgery</h2>
                  <p>
                    By integrating modern surgical techniques with a compassionate bedside manner, she ensures that even the most complex procedures are handled with minimal discomfort. She believes that every successful treatment begins with a comprehensive diagnosis and a structured plan tailored to the individual needs of the patient.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Prathyusha R for Excellence</h2>
                  <p>
                    Choosing Dr. Prathyusha R means opting for a surgeon who is committed to excellence, precision, and long-term health. For anyone seeking the best oral and maxillofacial surgeon and cosmetology specialist in Chennai, Dr. Prathyusha offers the perfect blend of academic brilliance and clinical mastery.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To help patients achieve their health and aesthetic goals through disciplined care and surgical mastery.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{fontSize: '1.1rem'}}>
                      "Set a goal, make a plan, do the work."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Prathyusha R's Philosophy</p>
                  </div>
                  <p>
                    This methodical approach ensures that her patients receive the highest standard of care, whether they are visiting for a minor oral procedure or a major cosmetology intervention.
                  </p>
                </div>

                {/* Practice Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Multispeciality Clinic</h4>
                      <p>Valasaravakkam, Chennai</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience expert surgical and aesthetic care with Dr. Prathyusha's precision-led approach.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download Doctor Profile as PDF
            </button>
          </div>
    </>
  )
}

export default PrathyushaDoc
